import { Controller } from "@hotwired/stimulus"

export default class SectionImagePickerController extends Controller {
  static targets = [
    "modal",
    "grid",
    "preview",
    "previewImage",
    "placeholder",
    "imageUrlInput",
    "fileInput",
    "urlInput",
    "clearBtn"
  ]

  static values = {
    currentCategory: { type: String, default: "all" }
  }

  connect() {
    this._boundHandleKeydown = this.handleKeydown.bind(this)

    if (this.hasImageUrlInputTarget && this.imageUrlInputTarget.value) {
      this._showPreview(this.imageUrlInputTarget.value)
    } else {
      this._hidePreview()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this._boundHandleKeydown)
  }

  open(event) {
    event.preventDefault()
    this.modalTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this._boundHandleKeydown)
  }

  close() {
    this.modalTarget.style.display = "none"
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this._boundHandleKeydown)
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  selectCategory(event) {
    const category = event.currentTarget.dataset.category
    this.currentCategoryValue = category

    const items = this.gridTarget.querySelectorAll(".section-picker__img-item")
    items.forEach(item => {
      item.style.display = (category === "all" || item.dataset.category === category) ? "" : "none"
    })

    const tabs = this.element.querySelectorAll("[data-action*='selectCategory']")
    tabs.forEach(tab => tab.classList.remove("section-picker__tab--active"))
    event.currentTarget.classList.add("section-picker__tab--active")
  }

  selectImage(event) {
    const path = event.currentTarget.dataset.path
    this.imageUrlInputTarget.value = path
    this._showPreview(path)

    const items = this.gridTarget.querySelectorAll(".section-picker__img-item")
    items.forEach(item => item.classList.remove("section-picker__img-item--selected"))
    event.currentTarget.classList.add("section-picker__img-item--selected")

    // 미리보기 갱신 트리거 (섹션 폼 디바운스 프리뷰 연동)
    this.imageUrlInputTarget.dispatchEvent(new Event("input", { bubbles: true }))

    setTimeout(() => this.close(), 200)
  }

  triggerFileUpload() {
    this.fileInputTarget.click()
  }

  uploadFile(event) {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this._showPreview(e.target.result)
      this.imageUrlInputTarget.value = ""
      this.imageUrlInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.close()
    }
    reader.readAsDataURL(file)
  }

  applyUrl() {
    const url = this.urlInputTarget.value.trim()
    if (!url) return

    this.imageUrlInputTarget.value = url
    this._showPreview(url)
    this.imageUrlInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.close()
  }

  clearSelection() {
    this.imageUrlInputTarget.value = ""
    this._hidePreview()
    this.imageUrlInputTarget.dispatchEvent(new Event("input", { bubbles: true }))

    if (this.hasGridTarget) {
      this.gridTarget.querySelectorAll(".section-picker__img-item")
        .forEach(item => item.classList.remove("section-picker__img-item--selected"))
    }

    try { this.fileInputTarget.value = "" } catch (_e) {}
  }

  _showPreview(url) {
    this.previewImageTarget.src = url
    this.previewTarget.style.display = "block"
    this.placeholderTarget.style.display = "none"
    this.clearBtnTarget.style.display = "inline-flex"
  }

  _hidePreview() {
    this.previewImageTarget.src = ""
    this.previewTarget.style.display = "none"
    this.placeholderTarget.style.display = "flex"
    this.clearBtnTarget.style.display = "none"
  }
}
